import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e60f9fc6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  class: "red-note"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "上传凭证（最多可上传3张）", -1));
const _hoisted_4 = {
  class: "img-box"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "update-bt"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "补充描述", -1));
const _hoisted_8 = {
  class: "btn-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_uploader = _resolveComponent("van-uploader");
  const _component_van_field = _resolveComponent("van-field");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.proof_imgs, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "img-info",
      key: index
    }, [_createVNode(_component_van_image, {
      fit: "fill",
      src: item
    }, null, 8, ["src"]), _createElementVNode("div", {
      class: "icon-closs delete",
      onClick: _withModifiers($event => $options.deleteImg(index), ["stop"])
    }, null, 8, _hoisted_5)]);
  }), 128)), $data.proof_imgs.length < 3 ? (_openBlock(), _createBlock(_component_van_uploader, {
    key: 0,
    accept: "image/*",
    "after-read": $options.afterRead
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_icon, {
      class: "icon",
      name: "plus"
    })])]),
    _: 1
  }, 8, ["after-read"])) : _createCommentVNode("", true)]), _hoisted_7, _createVNode(_component_van_field, {
    class: "textarea",
    modelValue: $data.describe,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.describe = $event),
    rows: "4",
    autosize: "",
    type: "textarea",
    maxlength: "10000",
    placeholder: "请输入补充描述……",
    "show-word-limit": ""
  }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: "btn cancel",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goBack && $options.goBack(...args))
  }, "取消"), _createElementVNode("div", {
    class: "btn submit",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.sub && $options.sub(...args))
  }, "提交")])])]));
}